export default __webpack_public_path__ + "static/media/EA_Hex.8ffece3e.svg";